export const scriptsActions = {
    GET_SCRIPT_DATA : 'GET_SCRIPT_DATA',
    GET_SCRIPT_DATA_WITHOUT_PACKAGE: 'GET_SCRIPT_DATA_WITHOUT_PACKAGE',
    RECIEVED_SCRIPT_DATA: 'RECIEVED_SCRIPT_DATA',
    RECIEVED_SCRIPT_DATA_WITHOUT_PACKAGE: 'RECIEVED_SCRIPT_DATA_WITHOUT_PACKAGE',
    REST_SCRIPT_DATA: 'REST_SCRIPT_DATA'
};

const initState = {
    scriptData : null
};

export const scriptsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case scriptsActions.RECIEVED_SCRIPT_DATA:
        case scriptsActions.RECIEVED_SCRIPT_DATA_WITHOUT_PACKAGE:
            return Object.assign({}, state, action.payload);

        case scriptsActions.REST_SCRIPT_DATA:
            return null;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/scriptsReducer.ts